import React from 'react';
import { IS_IPAD } from './utils';

export default function ShiftHint({ isVisible }) {
  return (
    <div
      className={`shift-hint fade-component ${isVisible ? 'visible' : 'hidden'}`}
    >
      <span>
        {IS_IPAD ? 'Use three fingers to adjust angle' : 'Hold down shift to rotate'}
      </span>
    </div>
  );
}
